import React from 'react'
import Partner1 from "../../assets/images/partner/partner1.png"
import Partner2 from "../../assets/images/partner/partner2.png"
import Partner3 from "../../assets/images/partner/partner3.png"
import Partner4 from "../../assets/images/partner/partner4.png"
import Slider from 'react-slick'

const Partners = () => {
    const partner = [
        Partner1,
        Partner2,
        Partner3,
        Partner4
    ]

    const settings = {
        dots: false,
        fade: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        waitForAnimate: false,
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                }
            }
        ]
    };
    return (
        <div>
            <div className="rs-partner partner-main-home pt-45 pb-45">
                <div className="container">
                    <Slider {...settings} className='align-items-center'>
                        {partner?.map((part, i) => {
                            return (
                                <div className={`logo-img ${i ===1 && 'lg-img'}`} key={i}>
                                    {/* <a href="#"> */}
                                    {/* <img className="hovers-logos rs-grid-img" src={part} title="" alt="" /> */}
                                    <div className='h-100 d-flex align-items-center justify-content-center'>
                                        <img className="mains-logos rs-grid-img bg-white " src={part} title="" alt="" />
                                    </div>
                                    {/* </a> */}
                                </div>
                            )
                        })}

                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default Partners
